module.exports = __webpack_public_path__ + "img/mobile-antidrooling-plan.1ef6e7e6.svg";